<template>

	<main class="col-xs-12 corte mainslider" v-if="loaded === 'true'" >
		<ul>
			<li v-for="slide in slider.post_meta_fields._slide_de_imagenes">
				<img v-bind:src="slide.large" alt="" width="1400">
			</li>
		</ul>
	</main>


</template>

<script>
export default {

	props:[
		'post_id',
	],
	mounted: function() {
		const vm = this;
		vm.getSlider();
	},

	data() {
		return {
			slider: [],
			loaded: 'false'
		};
	},

	methods: {
		getSlider: function() {
			const vm = this;
			vm.loaded = 'false';
			vm.$http.get( 'wp/v2/portada/'+vm.post_id)
				.then( ( res ) => {
					vm.slider = res.data;
					vm.loaded = 'true';
					vm.$nextTick(function () {
						activar_slider_portada();
						init_attach();
					});
				} )
				.catch( ( res ) => {
					console.log( `Something went wrong : ${ res }` );
				} );
		},
	}
};
</script>



// WEBPACK FOOTER //
// slideportada.vue?1a6c8da3